/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Splits_EmptyInputs */

const cs_deal_splits_empty = /** @type {(inputs: Deal_Splits_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné podíly na provizi — celá provize připadá přiřazenému makléři.`)
};

const en_deal_splits_empty = /** @type {(inputs: Deal_Splits_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No provision splits yet — full commission is credited to the assigned agent.`)
};

/**
* | output |
* | --- |
* | "No provision splits yet — full commission is credited to the assigned agent." |
*
* @param {Deal_Splits_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_empty = /** @type {((inputs?: Deal_Splits_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_empty(inputs)
	return cs_deal_splits_empty(inputs)
});